export default __webpack_public_path__ + "static/media/shlp.24783aef.svg";